import {Component, Input, OnInit} from '@angular/core';
import {FormControl} from "@angular/forms";
import {ValidationService} from "./validation.service";

@Component({
    selector: 'validation-messages',
    templateUrl: './validation-messages.component.html',
    styleUrls: ['./validation-messages.component.css']
})
export class ValidationMessagesComponent implements OnInit {

    @Input() control: FormControl;

    constructor() {
    }

    get errorMessages(): string[] {
        let messages = [];
        if (this.control) {
            for (let propertyName in this.control.errors) {
                if (!this.control.pristine) {
                    messages.push(ValidationService.getValidatorErrorMessage(propertyName, this.control.errors[propertyName]));
                }
            }
        }
        return messages;
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/core/validation-messages/validation-messages.component.ts